export const receipt = (params) => `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips">
  <PaperOrientation>Landscape</PaperOrientation>
  <Id>LargeLeverArch99019</Id>
  <PaperName>99019 Large Lever Arch</PaperName>
  <DrawCommands>
    <Rectangle X="0" Y="0" Width="3329" Height="10771"/>
  </DrawCommands>
  <ObjectInfo>
    <TextObject>
      <Name>TICKETSFROM</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>YOUR TICKETS FROM</String>
          <Attributes>
            <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="243.9008" Width="3976.043" Height="184.9011"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>SHOWTIX4UNAME</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>ShowTix4U</String>
          <Attributes>
            <Font Family="Arial" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="381.0043" Width="3972.307" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>SHOWTIX4UADDRESS</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>PO BOX 36133 LAS VEGAS NV 89133</String>
          <Attributes>
            <Font Family="Arial" Size="9" Bold="False" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="858.4077" Width="3985.143" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>PATRONNAME</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>Patron</String>
          <Attributes>
            <Font Family="Arial" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="1150" Width="8066" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>PATRONADDRESS</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>Address</String>
          <Attributes>
            <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="1400" Width="8066" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>PATRONADDRESS2</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>Address</String>
          <Attributes>
            <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="1650" Width="8066" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>PATRONCITYSTATEZIP</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>City State</String>
          <Attributes>
            <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="1507" Y="1900" Width="8066" Height="537.8085"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>ORDERINFO</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>TX ID</String>
          <Attributes>
            <Font Family="Helvetica" Size="10" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="6900" Y="2525.098" Width="2807.09" Height="279.2891"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>ORDERSUMMARY</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Left</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>Ticket</String>
          <Attributes>
            <Font Family="Helvetica" Size="9" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="6900" Y="2770.311" Width="3395.367" Height="279.2891"/>
  </ObjectInfo>
  <ObjectInfo>
    <TextObject>
      <Name>TRANSACTIONRECEIPT</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation270</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <HorizontalAlignment>Center</HorizontalAlignment>
      <VerticalAlignment>Top</VerticalAlignment>
      <TextFitMode>None</TextFitMode>
      <UseFullFontHeight>True</UseFullFontHeight>
      <Verticalized>False</Verticalized>
      <StyledText>
        <Element>
          <String>TRANSACTION RECEIPT</String>
          <Attributes>
            <Font Family="Lucida Grande" Size="13" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
            <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
          </Attributes>
        </Element>
      </StyledText>
    </TextObject>
    <Bounds X="9877.55" Y="57.60014" Width="537.8085" Height="3192"/>
  </ObjectInfo>
  <ObjectInfo>
    <ImageObject>
      <Name>TRANSACTIONBARCODE</Name>
      <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
      <LinkedObjectName></LinkedObjectName>
      <Rotation>Rotation0</Rotation>
      <IsMirrored>False</IsMirrored>
      <IsVariable>False</IsVariable>
      <Image>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</Image>
      <ScaleMode>Uniform</ScaleMode>
      <BorderWidth>0</BorderWidth>
      <BorderColor Alpha="255" Red="0" Green="0" Blue="0"/>
      <HorizontalAlignment>Center</HorizontalAlignment>
      <VerticalAlignment>Center</VerticalAlignment>
    </ImageObject>
    <Bounds X="6900" Y="57.60014" Width="3109.328" Height="1452.417"/>
  </ObjectInfo>
</DieCutLabel>`



// WEBPACK FOOTER //
// ./src/lib/labels/ShowTix4UReceipt.js